import { useContext } from "react";
import { useSelector } from "react-redux";
import {
  Alert,
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalBody,
} from "reactstrap";
import { isEmpty } from "lodash";

import SiteTitle from "./../../../helpers/SiteTitle/SiteTitle";
import Button from "../../../components/Button/Button";
import Icon from "../../../components/Icon/Icon";
import PageHeader from "./../../../components/PageHeader/PageHeader";
import InfoItem from "./../../../helpers/InfoItem/InfoItem";
import { Col, Row } from "./../../../components/Grid/Grid";
import { charter724AdminContext } from "../../../context/AdminContext/Charter724AdminContext/Charter724AdminContext";
import { convertDate, numberSeparate } from "../../../utils";

const Charter724Admin = () => {
  const loader = useSelector((state) => state.loader);

  const { info, setInfo, handleLogin, handleShowMyIP, handleGetCharge } =
    useContext(charter724AdminContext);

  return (
    <>
      <SiteTitle title="چارتر 724" />

      <PageHeader title="چارتر 724" description="" />

      <Card>
        <CardBody>
          <Row>
            <Col sm="6" md="4">
              <Card className="text-center">
                <CardHeader>نمایش IP ما</CardHeader>
                <CardBody>
                  <Button
                    size="lg"
                    loading={loader}
                    color="info"
                    className="btn-block"
                    onClick={handleShowMyIP}
                  >
                    نمایش
                  </Button>
                </CardBody>
              </Card>
            </Col>
            <Col sm="6" md="4">
              <Card className="text-center">
                <CardHeader>ورود به چارتر 724</CardHeader>
                <CardBody>
                  <Button
                    size="lg"
                    loading={loader}
                    color="success"
                    className="btn-block"
                    onClick={handleLogin}
                  >
                    ورود
                  </Button>
                </CardBody>
              </Card>
            </Col>
            <Col sm="6" md="4">
              <Card className="text-center">
                <CardHeader>دریافت شارژ</CardHeader>
                <CardBody>
                  <Button
                    size="lg"
                    loading={loader}
                    color="info"
                    className="btn-block"
                    onClick={handleGetCharge}
                  >
                    دریافت
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Modal
        isOpen={!isEmpty(info)}
        toggle={() => setInfo({})}
        className="modal-dialog-centered"
        size="xl"
      >
        <ModalBody>
          <span type="button" onClick={() => setInfo({})} className="close">
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h5 className="title">اطلاعات چارتر 724</h5>
            <br />
            {info?.msg === "login" && (
              <>
                <Row>
                  <Col sm="6">
                    <InfoItem title="تاریخ انقضا">
                      {convertDate(info?.data?.expires_Utc, "YYYY-MM-DD HH:mm")}
                    </InfoItem>
                  </Col>
                  <Col sm="6">
                    <InfoItem title="نوع توکن">
                      {info?.data?.token_type}
                    </InfoItem>
                  </Col>
                </Row>
                {info?.data?.access_token && (
                  <Alert color="success" className="text-center mt-3">
                    ورود با موفقیت انجام شد
                  </Alert>
                )}
              </>
            )}
            {info?.msg === "GetCharge" && (
              <>
                <Row>
                  <Col sm="6">
                    <InfoItem title="شارژ فرزند">
                      {numberSeparate(info?.data?.child_charge)}
                    </InfoItem>
                  </Col>
                  <Col sm="6">
                    <InfoItem title="شارژ والد">
                      {numberSeparate(info?.data?.parent_charge)}
                    </InfoItem>
                  </Col>
                  <Col sm="6">
                    <InfoItem title="پیام اصلی">{info?.data?.message}</InfoItem>
                  </Col>
                  <Col sm="6">
                    <InfoItem title="پیام کوتاه">{info?.data?.msg}</InfoItem>
                  </Col>
                </Row>
              </>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Charter724Admin;
